import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticleLinks() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full border border-accent-200 text-accent-700 text-xs font-medium mb-4">
            Blog & Guias
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Artigos e Guias CSSBuy
          </h2>
          <p className="text-foreground-500 text-base max-w-lg mx-auto">
            Aprenda tudo sobre CSSBuy Spreadsheet com nossos artigos completos e tutoriais passo a passo em português.
          </p>
        </div>

        {/* Articles grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {articles.map((article, index) => (
            <Link
              key={article.id}
              to={`/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer transition-shadow hover:shadow-md flex flex-col"
            >
              {/* Image */}
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.image}
                  alt={`CSSBuy Spreadsheet - ${article.title}`}
                  title={`CSSBuy Spreadsheet ${article.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading={index >= 4 ? "lazy" : undefined}
                />
              </div>
              {/* Content */}
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading text-foreground-950 font-semibold text-sm md:text-base mb-2 leading-snug group-hover:text-accent-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed mb-4 line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 text-accent-600 font-medium text-xs md:text-sm">
                  Ler Artigo Completo
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* View all link */}
        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border-2 border-primary-500 text-primary-500 font-medium text-sm cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors whitespace-nowrap"
          >
            Ver Site Principal
            <i className="ri-external-link-line text-base"></i>
          </a>
        </div>
      </div>
    </section>
  );
}